import React, { useState } from 'react';
import { ImagePlus, RefreshCw, X } from 'lucide-react';
import FileUploadPopup from '../../../components/popup/file-upload-popup';
import type { StorefrontImageMeta } from '../../../components/storefront-image-upload/storefront-image-upload';

/**
 * Logo / banner uploader for the brand storefront, in the brand flow's look
 * (.brd-upload). Same upload as the shared StorefrontImageUpload (the
 * influencer side keeps that one): FileUploadPopup → POST /upload.
 */
export function StoreImageUpload({ label, value, uploadPath, variant, onChange, onRemove }: {
  label: string;
  value: string;
  uploadPath: string;
  variant: 'logo' | 'banner';
  onChange: (meta: StorefrontImageMeta) => void;
  onRemove: () => void;
}) {
  const [open, setOpen] = useState(false);
  const size = variant === 'banner' ? '1600 × 500' : '500 × 500';

  return (
    <div className="brd-field">
      <div className="brd-field__label-row">
        <span className="brd-field__label">{label}</span>
        <span className="brd-field__counter">{size} recommended</span>
      </div>

      {value ? (
        <div className={`brd-store-img brd-store-img--${variant}`}>
          <img src={value} alt={label} />
          <button type="button" className="brd-icon-btn brd-icon-btn--round brd-store-img__remove" onClick={onRemove} aria-label={`Remove ${label.toLowerCase()}`}>
            <X size={16} />
          </button>
          <button type="button" className="brd-btn brd-btn--outline brd-btn--sm brd-store-img__replace" onClick={() => setOpen(true)}>
            <RefreshCw size={14} /> Replace
          </button>
        </div>
      ) : (
        <button type="button" className={`brd-upload brd-store-upload--${variant}`} onClick={() => setOpen(true)}>
          <span className="brd-upload__icon"><ImagePlus size={20} /></span>
          <span className="brd-upload__title">Upload {label.toLowerCase()}</span>
          <span className="brd-upload__hint">PNG or JPG · max 2 MB</span>
        </button>
      )}

      <FileUploadPopup
        openModal={open}
        onClose={() => setOpen(false)}
        acceptedFileTypes=".jpg, .jpeg, .png"
        path={uploadPath}
        coverImage={variant === 'banner'}
        coverImageDimensionText={`Recommended: ${size}`}
        onSend={(file: any) => {
          onChange({
            url: file.url,
            file_name: file.file_name,
            file_type: file.file_type,
            file_path: file.file_path,
            storage_size: file.storage_size,
          });
          setOpen(false);
        }}
      />
    </div>
  );
}
